"use client"

import { useEffect, useState } from "react"

export function ServiceDegradedBanner() {
  const [degraded, setDegraded] = useState(false)

  useEffect(() => {
    let stopped = false
    let request: AbortController | undefined

    const checkOrigin = async () => {
      if (document.hidden || request) return
      const controller = new AbortController()
      request = controller
      const timeout = window.setTimeout(() => controller.abort(), 5000)

      try {
        const response = await fetch("/api/health/live", {
          cache: "no-store",
          signal: controller.signal,
        })
        const origin = response.headers.get("X-HSVE-Origin")
        if (!stopped && response.ok && (origin === "home" || origin === "hetzner")) {
          setDegraded(origin === "hetzner")
        }
      } catch {
        // Retain the last confirmed origin while the connection is unavailable.
      } finally {
        window.clearTimeout(timeout)
        request = undefined
      }
    }

    void checkOrigin()
    const interval = window.setInterval(checkOrigin, 15000)
    document.addEventListener("visibilitychange", checkOrigin)

    return () => {
      stopped = true
      window.clearInterval(interval)
      document.removeEventListener("visibilitychange", checkOrigin)
      request?.abort()
    }
  }, [])

  return (
    <div role="status" aria-live="polite" aria-atomic="true">
      {degraded && (
        <div
          className="flex items-center justify-center gap-2 px-4 py-2 font-mono text-xs font-medium"
          style={{
            background: "var(--accent-soft)",
            color: "var(--accent)",
            borderBottom: "1px solid var(--accent-line)",
          }}
        >
          <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
          Service Degraded
        </div>
      )}
    </div>
  )
}
